import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// Realtime do cronograma: conecta ao namespace /schedule, entra na sala do
// cronograma aberto e dispara onChange quando o backend emite 'schedule:changed'.
function socketOrigin() {
 const base = process.env.REACT_APP_URL_CONSULTING_RESEARCH_API || '';
 return String(base)
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '');
}

export function useScheduleSocket(idSchedule, onChange) {
 const cbRef = useRef(onChange);
 cbRef.current = onChange;

 useEffect(() => {
  if (idSchedule == null || idSchedule === '') return undefined;
  const token = localStorage.getItem('access_token') || '';
  const socket = io(`${socketOrigin()}/schedule`, {
   auth: { token },
   transports: ['websocket'],
  });

  socket.on('connect', () => socket.emit('join', { id_schedule: idSchedule }));
  socket.on('schedule:changed', (payload) => {
   if (String(payload?.id_schedule) === String(idSchedule)) cbRef.current();
  });

  return () => {
   socket.emit('leave', { id_schedule: idSchedule });
   socket.disconnect();
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [idSchedule]);
}

// Realtime da listagem: dispara onChange a cada mutação de qualquer cronograma
// (o backend escopa o refetch ao grupo do usuário).
export function useScheduleListSocket(onChange) {
 const cbRef = useRef(onChange);
 cbRef.current = onChange;

 useEffect(() => {
  const token = localStorage.getItem('access_token') || '';
  const socket = io(`${socketOrigin()}/schedule`, {
   auth: { token },
   transports: ['websocket'],
  });
  socket.on('schedule:list-changed', () => cbRef.current());
  return () => {
   socket.disconnect();
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);
}
